import { useSelector } from "react-redux";
import { Placeholder } from "semantic-ui-react";

const LoadingImage = ({ className, children, commonLoading }) => {
  const loadingStatus = useSelector((state) => state.isLoaderStatus);
  const isDarkMode = useSelector((state) => state.isTheme === "dark");

  return loadingStatus || commonLoading ? (
    <Placeholder
      inverted={isDarkMode}
      className={`${className}`}
      style={{ animationPlayState: "paused" }}
    >
      <Placeholder.Image />
    </Placeholder>
  ) : (
    children
  );
};

export default LoadingImage;
